// Additional API wrappers for attendance + docs + careers + quote
import axios from 'axios';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const extraApi = {
    // Attendance
    punchAttendance: (p) => axios.post(`${API}/attendance/punch`, p).then(r => r.data),
    myAttendance: () => axios.get(`${API}/attendance/me`).then(r => r.data),
    // Phase 42 — admin can toggle daily attendance gate ON / OFF
    attendanceEnforcementStatus: () => axios.get(`${API}/attendance/enforcement-status`).then(r => r.data),
    adminGetAttendanceEnforcement: () => axios.get(`${API}/admin/attendance-enforcement`).then(r => r.data),
    adminSetAttendanceEnforcement: (enabled) => axios.put(`${API}/admin/attendance-enforcement`, { attendance_enforcement_enabled: !!enabled }).then(r => r.data),
    // Phase 48 — IP-based location fallback when GPS times out
    ipLocate: () => axios.get(`${API}/geo/ip-locate`).then(r => r.data),
    getMyAttendanceRecord: (id) => axios.get(`${API}/attendance/me/${id}`).then(r => r.data),
    adminListAttendance: (params = {}) => axios.get(`${API}/admin/attendance`, { params }).then(r => r.data),
    adminGetAttendance: (id) => axios.get(`${API}/admin/attendance/${id}`).then(r => r.data),
    adminReviewAttendance: (id, p) => axios.put(`${API}/admin/attendance/${id}/review`, p).then(r => r.data),

    // Application documents
    updateApplicationDocuments: (id, p) => axios.put(`${API}/applications/${id}/documents`, p).then(r => r.data),

    // Quote request (public)
    postQuoteRequest: (p) => axios.post(`${API}/quote-requests`, p).then(r => r.data),

    // Solar Saathi booking (public)
    postSaathiBooking: (p) => axios.post(`${API}/saathi-bookings`, p).then(r => r.data),

    // Phase 36 — Public Lead OTP verification (used by homepage forms:
    // Get Free Quote, Book Now, Solar Saathi). Toggle is admin-controlled
    // — when OFF the forms submit directly like before.
    publicLeadOtpRequired: () => axios.get(`${API}/public/public-lead-otp-required`).then(r => r.data),
    sendPublicOtp: (p) => axios.post(`${API}/public/otp/send`, p).then(r => r.data),
    verifyPublicOtp: (p) => axios.post(`${API}/public/otp/verify`, p).then(r => r.data),

    // Careers
    listCareers: () => axios.get(`${API}/careers`).then(r => r.data),
    applyCareer: (p) => axios.post(`${API}/careers/apply`, p).then(r => r.data),

    // Admin Career Applications (Phase 47.50)
    adminCareerApplications:      (params = {}) => {
        const qs = new URLSearchParams(params).toString();
        return axios.get(`${API}/admin/career-applications${qs ? `?${qs}` : ''}`).then(r => r.data);
    },
    adminUpdateCareerApp:         (id, payload) => axios.patch(`${API}/admin/career-applications/${id}`, payload).then(r => r.data),
    adminDeleteCareerApp:         (id) => axios.delete(`${API}/admin/career-applications/${id}`).then(r => r.data),
    adminCareerCvUrl:             (id) => `${API}/admin/career-applications/${id}/cv`,

    // Phase 47.51 — Admin CMS for Career Openings
    adminListCareerOpenings:      () => axios.get(`${API}/admin/career-openings`).then(r => r.data),
    adminReplaceCareerOpenings:   (openings) => axios.put(`${API}/admin/career-openings`, { openings }).then(r => r.data),
};
